import { requester } from '../utils';

export const setPasswordForLogin = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/setPassword`,
        method: 'PUT',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('set password error', err);
        reject(err);
      });
  });
};